import { ErrorService } from '../helpers/errorplugin'

const state = {
    logLevel: ErrorService.INFO,
    logStack: false
};

const actions = {
    setLogLevel({ commit }, newLevel) {
        commit('setLevel', newLevel)        
    },
    setLogStack({commit}, newVal) {
        commit('setStack', newVal)
    }
};

const mutations = {
    setLevel(state, newLevel) {
        state.logLevel = newLevel
        ErrorService.logLevel = newLevel
        ErrorService.onInfo("Logging Level changed to:" + newLevel)
    },
    setStack(state, newStack) {
        state.logStack = newStack
        ErrorService.onInfo("Logging Stack changed to:" + newStack)
    }
};

const getters = {
    logLevel: state => state.logLevel,
}

export const logging = {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
};